import { render, staticRenderFns } from "./tooltip4SortWith.vue?vue&type=template&id=803ac3e0&scoped=true&"
import script from "./tooltip4SortWith.vue?vue&type=script&lang=js&"
export * from "./tooltip4SortWith.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803ac3e0",
  null
  
)

export default component.exports